import { LegalLayout } from "@/components/LegalLayout";

const H = ({ children }) => (
  <h2 className="font-condensed text-lg font-semibold uppercase tracking-wide text-ink">{children}</h2>
);

const Terms = () => (
  <LegalLayout title="Terms of Purchase" testId="terms-page">
    <p>Last updated: 2026. By purchasing ALIGNMENT — Human Design for Business ("the product"), you agree to these terms.</p>

    <div>
      <H>The product</H>
      <p className="mt-2">ALIGNMENT is a digital product by Dasha Love, delivered with instant access after purchase for a one-time payment of $27 USD, processed securely via Stripe.</p>
    </div>

    <div>
      <H>Nature of the content</H>
      <p className="mt-2">ALIGNMENT explores Human Design and Gene Keys as tools for self-reflection and experimentation. It is educational and inspirational content — not scientific, medical, financial, legal, or psychological advice, and no specific business results are promised or guaranteed.</p>
    </div>

    <div>
      <H>License</H>
      <p className="mt-2">Your purchase grants you a personal, non-transferable license for your own use. Please don't redistribute, resell, or share the materials publicly.</p>
    </div>

    <div>
      <H>Refunds</H>
      <p className="mt-2">As a digital product with instant access, all sales are final except where a refund is required by applicable law. If you have trouble accessing your purchase, contact us and we'll make it right.</p>
    </div>

    <div>
      <H>Contact</H>
      <p className="mt-2">Questions about these terms: reach out via the contact email provided on your purchase receipt.</p>
    </div>
  </LegalLayout>
);

export default Terms;
